import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/setting',
  component: Layout,
  name: 'Config',
  meta: {
    title: '系统配置',
    icon: 'i-ep:setting',
    auth: 'setting',
  },
  children: [
    {
      path: 'index',
      name: 'SettingIndex',
      component: () => import('@/views/setting/index.vue'),
      meta: {
        title: '设置管理',
        icon: 'i-ep:document',
        auth: 'setting:manage',
      },
    },
  ],
}

export default routes
